module.exports = __webpack_public_path__ + "static/media/bike-art.d2bdf545.png";